import { Card, CardHeader } from 'reactstrap';
import styled from 'styled-components';

export const CardProtocolsContainer = styled(Card)`
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
`;

export const CardProtocolsHeaderContainer = styled(CardHeader)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media screen and (max-width: 40rem) {
    text-align: center;
    justify-content: center;
  }

  @media screen and (min-width: 40.02rem) and (max-width: 64rem) {
    text-align: center;
    justify-content: center;
  }

  @media screen and (min-width: 64.02rem) and (max-width: 96rem) {
    justify-content: flex-start;
  }
`;
